/* =========================================================
   LA COLECTIE — LIVE / LIGHT V3
   Produs: placheta-auto-aurie

   - default "Fara date tehnice"
   - A5/A6 la finalul configuratorului, deasupra ATC
   - auto-scroll la loader/preview dupa upload
   - preview fortat 1:1 inclusiv desktop
   - 3 beneficii simple
   - loader premium cu turometru SVG
   ========================================================= */

(function () {
  if (window.__lcLiveLightV3) return;
  window.__lcLiveLightV3 = true;

  const body = document.body;
  const hero = document.querySelector('.lc-hero');

  if (!hero) return;

  const media = hero.querySelector('.lc-hero__media');
  const price = hero.querySelector('.lc-price');
  const variants = hero.querySelector('.lc-variants');

  const heroSelector =
    hero.id
      ? '#' + hero.id
      : '.lc-hero';

  const GENERATE_ENDPOINT =
    '/service/storefront/image/processing/generate';

  const FINAL_IMAGE_PATH =
    'customily.s3-us-west-1.amazonaws.com/js-lib-temp-images/';

  body.classList.add('lc-live-light');


  /* =========================================================
     CSS
     ========================================================= */

  const style =
    document.createElement('style');


  style.id =
    'lc-live-light-style-v3';


  style.textContent = `

    /* =====================================================
       CURATAM HERO-UL VECHI
       ===================================================== */

    body.lc-live-light
    ${heroSelector}
    .lc-hero-usps,

    body.lc-live-light
    ${heroSelector}
    .lc-price-preview-link {
      display: none !important;
    }


    /* =====================================================
       A5 / A6

       Il ascundem pana cand il putem pune
       la finalul configuratorului.
       ===================================================== */

    body.lc-live-light:not(.lc-size-placed)
    ${heroSelector}
    .lc-variants {
      display: none !important;
    }


    body.lc-live-light.lc-size-placed
    ${heroSelector}
    .lc-variants {
      display: block !important;
    }


    /* =====================================================
       3 BENEFICII
       ===================================================== */

    .lc-live-benefits {
      display: flex;

      flex-direction: column;

      gap: 8px;

      width: 100%;

      margin:
        14px
        0
        18px;

      box-sizing: border-box;
    }


    .lc-live-benefit {
      display: flex;

      align-items: center;

      gap: 9px;

      min-width: 0;

      color: #5f5a52;

      font-size: 13px;

      font-weight: 500;

      line-height: 1.4;

      text-align: left;
    }


    .lc-live-benefit--primary {
      color: #161616;

      font-weight: 800;
    }


    .lc-live-benefit__icon {
      display: flex;

      align-items: center;
      justify-content: center;

      width: 22px;
      height: 22px;

      flex:
        0
        0
        22px;

      border-radius: 50%;

      background:
        rgba(177,138,70,.10);

      color: #9A7335;
    }


    .lc-live-benefit__icon svg {
      display: block;

      width: 14px;
      height: 14px;

      fill: none;

      stroke: currentColor;

      stroke-width: 2;

      stroke-linecap: round;
      stroke-linejoin: round;
    }


    /* =====================================================
       PREVIEW = 1:1
       ===================================================== */

    body.lc-live-light.lc-customily-preview-active
    ${heroSelector}
    .lc-hero__media {
      width: 100% !important;

      height: auto !important;

      min-height: 0 !important;

      max-height: none !important;

      aspect-ratio:
        1 / 1 !important;

      position: relative !important;

      isolation: isolate !important;
    }


    body.lc-live-light.lc-customily-preview-active
    ${heroSelector}
    .lc-gallery,

    body.lc-live-light.lc-customily-preview-active
    ${heroSelector}
    .lc-gallery__slide {
      width: 100% !important;

      height: 100% !important;

      min-height: 0 !important;

      max-height: none !important;
    }


    body.lc-live-light.lc-customily-preview-active
    ${heroSelector}
    .lc-gallery__asset {
      width: 100% !important;

      height: 100% !important;

      object-fit: contain !important;

      object-position: center !important;
    }


    body.lc-live-light.lc-customily-preview-active
    ${heroSelector}
    .lc-canvas-container,

    body.lc-live-light.lc-customily-preview-active
    ${heroSelector}
    .cl-canvas-container,

    body.lc-live-light.lc-customily-preview-active
    ${heroSelector}
    .customily-canvas-container,

    body.lc-live-light.lc-customily-preview-active
    ${heroSelector}
    .canvas-wrapper {
      width: 100% !important;

      height: 100% !important;

      min-height: 0 !important;

      max-width: 100% !important;

      max-height: 100% !important;

      aspect-ratio:
        1 / 1 !important;

      box-sizing:
        border-box !important;
    }


    body.lc-live-light.lc-customily-preview-active
    ${heroSelector}
    canvas {
      max-width: 100% !important;

      max-height: 100% !important;
    }


    /* =====================================================
       LOADER
       ===================================================== */

    body.lc-live-light
    ${heroSelector}
    .lc-hero__media {
      position: relative !important;

      isolation: isolate !important;
    }


    .lc-live-loader {
      position: absolute;

      inset: 0;

      z-index: 99999;

      display: flex;

      flex-direction: column;

      align-items: center;
      justify-content: center;

      box-sizing: border-box;

      padding:
        28px
        24px;

      overflow: hidden;

      background:
        radial-gradient(
          circle at 50% 38%,
          rgba(177,138,70,.11),
          transparent 35%
        ),
        linear-gradient(
          155deg,
          #151515 0%,
          #090909 70%,
          #12100d 100%
        );

      color: #F5F3EE;

      text-align: center;

      opacity: 0;

      visibility: hidden;

      pointer-events: none;

      transition:
        opacity .18s ease,
        visibility .18s ease;
    }


    body.lc-live-loader-active
    .lc-live-loader {
      opacity: 1;

      visibility: visible;

      pointer-events: auto;
    }


    .lc-live-loader::after {
      content: "";

      position: absolute;

      width: 55%;
      height: 160%;

      top: -30%;
      left: -70%;

      transform:
        rotate(18deg);

      background:
        linear-gradient(
          90deg,
          transparent,
          rgba(225,193,123,.08),
          transparent
        );

      animation:
        lcLiveSweep
        2.8s
        ease-in-out
        infinite;

      pointer-events: none;
    }


    @keyframes lcLiveSweep {

      0%,
      16% {
        left: -70%;

        opacity: 0;
      }

      28% {
        opacity: 1;
      }

      62% {
        left: 115%;

        opacity: .8;
      }

      72%,
      100% {
        left: 115%;

        opacity: 0;
      }

    }


    .lc-live-loader__gauge,
    .lc-live-loader__message,
    .lc-live-loader__time,
    .lc-live-loader__progress {
      position: relative;

      z-index: 2;
    }


    /* =====================================================
       TUROMETRU SVG
       ===================================================== */

    .lc-live-loader__gauge {
      position: relative;

      width: 230px;
      height: 180px;

      flex:
        0
        0
        180px;

      margin:
        0
        0
        15px;

      padding: 0;

      border: 0;

      background: none;

      overflow: visible;
    }


    .lc-real-tacho {
      display: block;

      width: 230px;
      height: 180px;

      overflow: visible;

      filter:
        drop-shadow(
          0
          15px
          30px
          rgba(0,0,0,.55)
        );
    }


    .lc-real-tacho__outer {
      fill:
        rgba(15,15,15,.95);

      stroke:
        rgba(255,255,255,.07);

      stroke-width: 2;
    }


    .lc-real-tacho__inner {
      fill:
        url(#lcTachoFaceV3);

      stroke:
        rgba(177,138,70,.16);

      stroke-width: 1.5;
    }


    .lc-real-tacho__arc-bg {
      fill: none;

      stroke:
        rgba(255,255,255,.075);

      stroke-width: 7;

      stroke-linecap: round;
    }


    .lc-real-tacho__arc-gold {
      fill: none;

      stroke:
        url(#lcTachoGoldV3);

      stroke-width: 7;

      stroke-linecap: round;

      opacity: .9;
    }


    .lc-real-tacho__redline {
      fill: none;

      stroke: #9B4A3D;

      stroke-width: 7;

      stroke-linecap: round;

      opacity: .9;
    }


    .lc-real-tacho__tick {
      stroke:
        rgba(238,234,223,.52);

      stroke-width: 1.5;

      stroke-linecap: round;
    }


    .lc-real-tacho__tick--major {
      stroke:
        rgba(238,234,223,.92);

      stroke-width: 2.5;
    }


    .lc-real-tacho__tick--red {
      stroke: #C56A58;
    }


    .lc-real-tacho__number {
      fill:
        rgba(245,243,238,.72);

      font-family:
        Arial,
        sans-serif;

      font-size: 11px;

      font-weight: 700;

      text-anchor: middle;

      dominant-baseline: middle;
    }


    .lc-real-tacho__number--red {
      fill: #D8816F;
    }


    .lc-real-tacho__needle-shadow {
      stroke:
        rgba(0,0,0,.6);

      stroke-width: 7;

      stroke-linecap: round;
    }


    .lc-real-tacho__needle-line {
      stroke:
        url(#lcNeedleGoldV3);

      stroke-width: 4;

      stroke-linecap: round;

      filter:
        drop-shadow(
          0
          0
          5px
          rgba(231,199,126,.55)
        );
    }


    .lc-real-tacho__hub-outer {
      fill: #090909;

      stroke:
        rgba(255,255,255,.13);

      stroke-width: 2;
    }


    .lc-real-tacho__hub {
      fill:
        url(#lcHubGoldV3);

      filter:
        drop-shadow(
          0
          0
          8px
          rgba(177,138,70,.55)
        );
    }


    .lc-real-tacho__readout {
      fill: #E3C47C;

      font-family:
        Arial,
        sans-serif;

      font-size: 15px;

      font-weight: 800;

      text-anchor: middle;

      letter-spacing: .02em;
    }


    .lc-real-tacho__unit {
      fill:
        rgba(245,243,238,.44);

      font-family:
        Arial,
        sans-serif;

      font-size: 7px;

      font-weight: 700;

      text-anchor: middle;

      letter-spacing: .16em;
    }


    .lc-live-loader__message {
      min-height: 44px;

      max-width: 360px;

      display: flex;

      align-items: center;
      justify-content: center;

      color: #F5F3EE;

      font-size: 18px;

      font-weight: 750;

      line-height: 1.3;

      letter-spacing: -.01em;
    }


    .lc-live-loader__time {
      display: inline-flex;

      align-items: center;

      gap: 8px;

      margin-top: 10px;

      padding:
        7px
        11px;

      border:
        1px solid
        rgba(177,138,70,.25);

      border-radius: 999px;

      background:
        rgba(177,138,70,.07);

      color:
        rgba(245,243,238,.62);

      font-size: 11px;

      font-weight: 650;

      line-height: 1;
    }


    .lc-live-loader__dot {
      width: 6px;
      height: 6px;

      border-radius: 50%;

      background: #B18A46;

      box-shadow:
        0
        0
        9px
        rgba(177,138,70,.8);

      animation:
        lcLivePulse
        1.15s
        ease-in-out
        infinite;
    }


    @keyframes lcLivePulse {

      0%,
      100% {
        opacity: .35;

        transform:
          scale(.86);
      }

      50% {
        opacity: 1;

        transform:
          scale(1.16);
      }

    }


    .lc-live-loader__progress {
      position: relative;

      width:
        min(
          260px,
          72%
        );

      height: 3px;

      margin-top: 20px;

      overflow: hidden;

      border-radius: 999px;

      background:
        rgba(255,255,255,.07);
    }


    .lc-live-loader__progress::after {
      content: "";

      position: absolute;

      top: 0;
      bottom: 0;
      left: 0;

      width: 40%;

      border-radius: inherit;

      background:
        linear-gradient(
          90deg,
          transparent,
          #B18A46 28%,
          #F0D898 68%,
          transparent
        );

      animation:
        lcLiveRoad
        1.45s
        ease-in-out
        infinite;
    }


    @keyframes lcLiveRoad {

      from {
        transform:
          translateX(-130%);
      }

      to {
        transform:
          translateX(360%);
      }

    }


    @media (max-width: 480px) {

      .lc-live-benefit {
        font-size: 12.5px;
      }


      .lc-live-loader {
        padding:
          24px
          20px;
      }


      .lc-live-loader__gauge {
        width: 210px;

        height: 165px;

        flex-basis: 165px;
      }


      .lc-real-tacho {
        width: 210px;

        height: 165px;
      }


      .lc-live-loader__message {
        max-width: 310px;

        font-size: 17px;
      }

    }

  `;


  document.head.appendChild(
    style
  );


  /* =========================================================
     3 BENEFICII
     ========================================================= */

  if (
    price &&
    !hero.querySelector(
      '.lc-live-benefits'
    )
  ) {

    const benefits =
      document.createElement(
        'div'
      );


    benefits.className =
      'lc-live-benefits';


    benefits.innerHTML = `

      <div
        class="lc-live-benefit lc-live-benefit--primary"
      >

        <span
          class="lc-live-benefit__icon"
          aria-hidden="true"
        >

          <svg viewBox="0 0 24 24">

            <path
              d="m5 12 4 4L19 6"
            ></path>

          </svg>

        </span>

        <span>
          VEZI GRATUIT SIMULAREA CU MAȘINA TA PE PLACHETĂ
        </span>

      </div>


      <div
        class="lc-live-benefit"
      >

        <span
          class="lc-live-benefit__icon"
          aria-hidden="true"
        >

          <svg viewBox="0 0 24 24">

            <circle
              cx="12"
              cy="12"
              r="8"
            ></circle>

            <path
              d="M12 7v5l3 2"
            ></path>

          </svg>

        </span>

        <span>
          Gata în aproximativ 20 de secunde
        </span>

      </div>


      <div
        class="lc-live-benefit"
      >

        <span
          class="lc-live-benefit__icon"
          aria-hidden="true"
        >

          <svg viewBox="0 0 24 24">

            <path
              d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8Z"
            ></path>

          </svg>

        </span>

        <span>
          Comanzi doar dacă îți place rezultatul
        </span>

      </div>

    `;


    price.insertAdjacentElement(
      'afterend',
      benefits
    );

  }


  /* =========================================================
     DEFAULT ROBUST:
     FARA DATE TEHNICE

     cl-value-id-0 = Cu date tehnice
     cl-value-id-1 = Fara date tehnice
     ========================================================= */

  let plaqueUserTouched =
    false;


  let defaultAttempts =
    0;


  function getPlaqueRadios() {

    return Array.from(
      document.querySelectorAll(
        '.lc-plaque-type input[type="radio"]'
      )
    );

  }


  function findLabelForRadio(
    radio
  ) {

    if (
      !radio ||
      !radio.id
    ) {

      return null;

    }


    return Array.from(
      document.querySelectorAll(
        'label'
      )
    ).find(
      function (label) {

        return label.htmlFor ===
          radio.id;

      }
    ) || null;

  }


  function findMinimalistRadio() {

    const radios =
      getPlaqueRadios();


    const byId =
      radios.find(
        function (radio) {

          return String(
            radio.id || ''
          ).endsWith(
            '-cl-value-id-1'
          );

        }
      );


    if (
      byId
    ) {

      return byId;

    }


    for (
      const radio
      of radios
    ) {

      const label =
        findLabelForRadio(
          radio
        );


      const text =
        (
          (
            label &&
            label.textContent
          ) ||
          radio.value ||
          ''
        )
          .trim()
          .toLowerCase();


      if (
        text.includes(
          'fără date tehnice'
        ) ||
        text.includes(
          'fara date tehnice'
        )
      ) {

        return radio;

      }

    }


    return null;

  }


  function applyMinimalistDefault() {

    if (
      plaqueUserTouched
    ) {

      return false;

    }


    const minimalist =
      findMinimalistRadio();


    if (
      !minimalist
    ) {

      return false;

    }


    defaultAttempts +=
      1;


    /*
      Customily poate crea radio-ul inainte
      ca runtime-ul sa fie 100% pregatit.

      De aceea reconfirmam selectia de mai multe ori,
      nu facem doar un click prea devreme.
    */

    if (
      !minimalist.checked
    ) {

      const label =
        findLabelForRadio(
          minimalist
        );


      if (
        label
      ) {

        label.click();

      } else {

        minimalist.click();

      }

    }


    minimalist.checked =
      true;


    minimalist.dispatchEvent(
      new Event(
        'input',
        {
          bubbles: true
        }
      )
    );


    minimalist.dispatchEvent(
      new Event(
        'change',
        {
          bubbles: true
        }
      )
    );


    return true;

  }


  document.addEventListener(
    'pointerdown',
    function (event) {

      const target =
        event.target;


      if (
        !(target instanceof Element)
      ) {

        return;

      }


      const plaqueSection =
        target.closest(
          '.customily_section'
        );


      if (
        plaqueSection &&
        plaqueSection.querySelector(
          '.lc-plaque-type'
        )
      ) {

        plaqueUserTouched =
          true;

      }

    },
    true
  );


  document.addEventListener(
    'change',
    function (event) {

      const target =
        event.target;


      if (
        !(target instanceof HTMLInputElement)
      ) {

        return;

      }


      if (
        target.matches(
          '.lc-plaque-type input[type="radio"]'
        ) &&
        event.isTrusted
      ) {

        plaqueUserTouched =
          true;

      }

    },
    true
  );


  const plaqueDefaultTimer =
    setInterval(
      function () {

        if (
          plaqueUserTouched
        ) {

          clearInterval(
            plaqueDefaultTimer
          );


          return;

        }


        applyMinimalistDefault();


        if (
          defaultAttempts >=
          10
        ) {

          clearInterval(
            plaqueDefaultTimer
          );

        }

      },
      700
    );


  applyMinimalistDefault();


  /* =========================================================
     A5/A6 LA FINALUL CONFIGURATORULUI

     Il punem imediat deasupra
     #customily-cart-btn.
     ========================================================= */

  function placeSizeSelectorAtEnd() {

    if (
      !variants
    ) {

      return false;

    }


    const cartButton =

      hero.querySelector(
        '#customily-cart-btn'
      ) ||

      document.querySelector(
        '#customily-cart-btn'
      );


    if (
      !cartButton
    ) {

      return false;

    }


    const cartSection =

      cartButton.closest(
        '.customily_section'
      ) ||

      cartButton.parentElement;


    if (
      !cartSection ||
      !cartSection.parentElement
    ) {

      return false;

    }


    const parent =
      cartSection.parentElement;


    if (
      variants.parentElement !==
        parent ||

      variants.nextElementSibling !==
        cartSection
    ) {

      parent.insertBefore(
        variants,
        cartSection
      );

    }


    body.classList.add(
      'lc-size-placed'
    );


    return true;

  }


  placeSizeSelectorAtEnd();


  let sizePlacementFrame =
    null;


  const sizeObserver =
    new MutationObserver(
      function () {

        if (
          sizePlacementFrame
        ) {

          return;

        }


        sizePlacementFrame =
          requestAnimationFrame(
            function () {

              placeSizeSelectorAtEnd();


              sizePlacementFrame =
                null;

            }
          );

      }
    );


  sizeObserver.observe(
    hero,
    {
      childList: true,
      subtree: true
    }
  );


  /* =========================================================
     PREVIEW 1:1 — HARD FIX

     Pe desktop nu ne mai bazam doar
     pe aspect-ratio.

     Punem efectiv:
     height = width.
     ========================================================= */

  function enforceSquarePreview() {

    if (
      !media
    ) {

      return;

    }


    body.classList.add(
      'lc-customily-preview-active'
    );


    const width =
      media.getBoundingClientRect()
        .width;


    if (
      width > 0
    ) {

      const square =
        Math.round(
          width
        ) +
        'px';


      media.style.setProperty(
        'height',
        square,
        'important'
      );


      media.style.setProperty(
        'min-height',
        square,
        'important'
      );


      media.style.setProperty(
        'max-height',
        square,
        'important'
      );


      media.style.setProperty(
        'aspect-ratio',
        '1 / 1',
        'important'
      );

    }


    const squareNodes =
      media.querySelectorAll(
        [
          '.lc-gallery',
          '.lc-gallery__slide',
          '.lc-canvas-container',
          '.cl-canvas-container',
          '.customily-canvas-container',
          '.canvas-wrapper'
        ].join(',')
      );


    squareNodes.forEach(
      function (node) {

        node.style.setProperty(
          'width',
          '100%',
          'important'
        );


        node.style.setProperty(
          'height',
          '100%',
          'important'
        );


        node.style.setProperty(
          'max-width',
          '100%',
          'important'
        );


        node.style.setProperty(
          'max-height',
          '100%',
          'important'
        );


        node.style.setProperty(
          'aspect-ratio',
          '1 / 1',
          'important'
        );

      }
    );

  }


  window.addEventListener(
    'resize',
    function () {

      if (
        body.classList.contains(
          'lc-customily-preview-active'
        )
      ) {

        enforceSquarePreview();

      }

    },
    {
      passive: true
    }
  );


  /* =========================================================
     AUTO SCROLL LA GALERIE / LOADER
     ========================================================= */

  function scrollToPreview() {

    if (
      !media
    ) {

      return;

    }


    const offset =
      window.innerWidth < 750
        ? 72
        : 92;


    const targetY =

      media.getBoundingClientRect()
        .top +

      window.scrollY -

      offset;


    window.scrollTo({
      top:
        Math.max(
          0,
          targetY
        ),

      behavior:
        'smooth'
    });

  }


  function bringPreviewIntoView() {

    scrollToPreview();


    setTimeout(
      scrollToPreview,
      140
    );

  }


  /* =========================================================
     LOADER DOM
     ========================================================= */

  let loader =
    null;


  let messageNode =
    null;


  let needleNode =
    null;


  let readoutNode =
    null;


  let tachometerFrame =
    null;


  let tachometerStart =
    null;


  if (
    media
  ) {

    loader =
      document.createElement(
        'div'
      );


    loader.className =
      'lc-live-loader';


    loader.setAttribute(
      'aria-live',
      'polite'
    );


    loader.setAttribute(
      'aria-hidden',
      'true'
    );


    loader.innerHTML = `

      <div
        class="lc-live-loader__gauge"
        aria-hidden="true"
      ></div>


      <div
        class="lc-live-loader__message"
      >
        Încărcăm și pregătim fotografia...
      </div>


      <div
        class="lc-live-loader__time"
      >

        <span
          class="lc-live-loader__dot"
          aria-hidden="true"
        ></span>

        <span>
          De obicei durează în jur de 20 de secunde
        </span>

      </div>


      <div
        class="lc-live-loader__progress"
        aria-hidden="true"
      ></div>

    `;


    media.appendChild(
      loader
    );


    messageNode =
      loader.querySelector(
        '.lc-live-loader__message'
      );

  }


  /* =========================================================
     TUROMETRU SVG PREMIUM
     ========================================================= */

  function buildRealTachometer() {

    if (
      !loader
    ) {

      return;

    }


    const gauge =
      loader.querySelector(
        '.lc-live-loader__gauge'
      );


    if (
      !gauge
    ) {

      return;

    }


    const NS =
      'http://www.w3.org/2000/svg';


    const svg =
      document.createElementNS(
        NS,
        'svg'
      );


    svg.setAttribute(
      'viewBox',
      '0 0 240 180'
    );


    svg.setAttribute(
      'class',
      'lc-real-tacho'
    );


    svg.setAttribute(
      'aria-hidden',
      'true'
    );


    svg.innerHTML = `

      <defs>

        <radialGradient
          id="lcTachoFaceV3"
          cx="50%"
          cy="42%"
          r="65%"
        >

          <stop
            offset="0%"
            stop-color="#202020"
          />

          <stop
            offset="60%"
            stop-color="#101010"
          />

          <stop
            offset="100%"
            stop-color="#080808"
          />

        </radialGradient>


        <linearGradient
          id="lcTachoGoldV3"
          x1="0"
          y1="0"
          x2="1"
          y2="1"
        >

          <stop
            offset="0%"
            stop-color="#7A5720"
          />

          <stop
            offset="45%"
            stop-color="#B18A46"
          />

          <stop
            offset="75%"
            stop-color="#E2C37D"
          />

          <stop
            offset="100%"
            stop-color="#9D7430"
          />

        </linearGradient>


        <linearGradient
          id="lcNeedleGoldV3"
          x1="0"
          y1="1"
          x2="0"
          y2="0"
        >

          <stop
            offset="0%"
            stop-color="#9A6E28"
          />

          <stop
            offset="65%"
            stop-color="#DDBF78"
          />

          <stop
            offset="100%"
            stop-color="#FFF0BE"
          />

        </linearGradient>


        <radialGradient
          id="lcHubGoldV3"
          cx="35%"
          cy="28%"
          r="75%"
        >

          <stop
            offset="0%"
            stop-color="#FFF0BB"
          />

          <stop
            offset="35%"
            stop-color="#C99C4A"
          />

          <stop
            offset="75%"
            stop-color="#8B6121"
          />

          <stop
            offset="100%"
            stop-color="#4F3510"
          />

        </radialGradient>

      </defs>


      <circle
        class="lc-real-tacho__outer"
        cx="120"
        cy="92"
        r="88"
      />


      <circle
        class="lc-real-tacho__inner"
        cx="120"
        cy="92"
        r="80"
      />


      <circle
        class="lc-real-tacho__arc-bg"
        cx="120"
        cy="92"
        r="70"
        pathLength="100"
        stroke-dasharray="75 25"
        transform="rotate(135 120 92)"
      />


      <circle
        class="lc-real-tacho__arc-gold"
        cx="120"
        cy="92"
        r="70"
        pathLength="100"
        stroke-dasharray="60 40"
        transform="rotate(135 120 92)"
      />


      <circle
        class="lc-real-tacho__redline"
        cx="120"
        cy="92"
        r="70"
        pathLength="100"
        stroke-dasharray="14 86"
        stroke-dashoffset="-61"
        transform="rotate(135 120 92)"
      />


      <g
        class="lc-real-tacho__ticks-group"
      ></g>


      <g
        class="lc-real-tacho__numbers-group"
      ></g>


      <g
        class="lc-real-tacho__needle-group"
      >

        <line
          class="lc-real-tacho__needle-shadow"
          x1="120"
          y1="98"
          x2="120"
          y2="34"
        />


        <line
          class="lc-real-tacho__needle-line"
          x1="120"
          y1="98"
          x2="120"
          y2="32"
        />

      </g>


      <circle
        class="lc-real-tacho__hub-outer"
        cx="120"
        cy="92"
        r="11"
      />


      <circle
        class="lc-real-tacho__hub"
        cx="120"
        cy="92"
        r="7"
      />


      <text
        class="lc-real-tacho__readout"
        x="120"
        y="135"
      >
        0.0
      </text>


      <text
        class="lc-real-tacho__unit"
        x="120"
        y="149"
      >
        x1000 RPM
      </text>

    `;


    gauge.appendChild(
      svg
    );


    const ticksGroup =
      svg.querySelector(
        '.lc-real-tacho__ticks-group'
      );


    const numbersGroup =
      svg.querySelector(
        '.lc-real-tacho__numbers-group'
      );


    const cx =
      120;


    const cy =
      92;


    const startAngle =
      135;


    const totalAngle =
      270;


    const tickCount =
      40;


    for (
      let i = 0;
      i <= tickCount;
      i++
    ) {

      const angle =
        startAngle +
        (
          totalAngle *
          i /
          tickCount
        );


      const rad =
        angle *
        Math.PI /
        180;


      const major =
        i % 5 === 0;


      const value =
        i /
        5;


      const red =
        value >= 7;


      const outerRadius =
        65;


      const innerRadius =
        major
          ? 55
          : 59;


      const line =
        document.createElementNS(
          NS,
          'line'
        );


      line.setAttribute(
        'x1',
        cx +
        Math.cos(rad) *
        innerRadius
      );


      line.setAttribute(
        'y1',
        cy +
        Math.sin(rad) *
        innerRadius
      );


      line.setAttribute(
        'x2',
        cx +
        Math.cos(rad) *
        outerRadius
      );


      line.setAttribute(
        'y2',
        cy +
        Math.sin(rad) *
        outerRadius
      );


      line.setAttribute(
        'class',
        [
          'lc-real-tacho__tick',

          major
            ? 'lc-real-tacho__tick--major'
            : '',

          red
            ? 'lc-real-tacho__tick--red'
            : ''

        ]
          .filter(Boolean)
          .join(' ')
      );


      ticksGroup.appendChild(
        line
      );


      if (
        major
      ) {

        const numberRadius =
          45;


        const text =
          document.createElementNS(
            NS,
            'text'
          );


        text.setAttribute(
          'x',
          cx +
          Math.cos(rad) *
          numberRadius
        );


        text.setAttribute(
          'y',
          cy +
          Math.sin(rad) *
          numberRadius
        );


        text.setAttribute(
          'class',
          red
            ? 'lc-real-tacho__number lc-real-tacho__number--red'
            : 'lc-real-tacho__number'
        );


        text.textContent =
          String(
            Math.round(
              value
            )
          );


        numbersGroup.appendChild(
          text
        );

      }

    }


    needleNode =
      svg.querySelector(
        '.lc-real-tacho__needle-group'
      );


    readoutNode =
      svg.querySelector(
        '.lc-real-tacho__readout'
      );

  }


  const needleFrames = [

    {
      at: 0,
      angle: -132
    },

    {
      at: .13,
      angle: -103
    },

    {
      at: .31,
      angle: 18
    },

    {
      at: .42,
      angle: -8
    },

    {
      at: .58,
      angle: 83
    },

    {
      at: .68,
      angle: 55
    },

    {
      at: .82,
      angle: 119
    },

    {
      at: 1,
      angle: -132
    }

  ];


  function easeInOut(
    value
  ) {

    return value < .5

      ? 4 *
        value *
        value *
        value

      : 1 -
        Math.pow(
          -2 *
          value +
          2,
          3
        ) /
        2;

  }


  function interpolateNeedle(
    progress
  ) {

    for (
      let i = 0;
      i < needleFrames.length - 1;
      i++
    ) {

      const a =
        needleFrames[i];


      const b =
        needleFrames[i + 1];


      if (
        progress >= a.at &&
        progress <= b.at
      ) {

        const local =
          (
            progress -
            a.at
          ) /
          (
            b.at -
            a.at
          );


        const eased =
          easeInOut(
            local
          );


        return (
          a.angle +
          (
            b.angle -
            a.angle
          ) *
          eased
        );

      }

    }


    return needleFrames[0].angle;

  }


  function animateTachometer(
    now
  ) {

    if (
      !body.classList.contains(
        'lc-live-loader-active'
      )
    ) {

      tachometerFrame =
        null;


      tachometerStart =
        null;


      return;

    }


    if (
      tachometerStart === null
    ) {

      tachometerStart =
        now;

    }


    const cycle =
      2550;


    const progress =
      (
        (
          now -
          tachometerStart
        ) %
        cycle
      ) /
      cycle;


    const angle =
      interpolateNeedle(
        progress
      );


    if (
      needleNode
    ) {

      needleNode.setAttribute(
        'transform',
        'rotate(' +
          angle +
          ' 120 92)'
      );

    }


    if (
      readoutNode
    ) {

      const normalized =
        Math.max(
          0,
          Math.min(
            1,
            (
              angle +
              135
            ) /
            270
          )
        );


      readoutNode.textContent =
        (
          normalized *
          8
        ).toFixed(1);

    }


    tachometerFrame =
      requestAnimationFrame(
        animateTachometer
      );

  }


  function startTachometer() {

    if (
      tachometerFrame !== null
    ) {

      return;

    }


    tachometerStart =
      null;


    tachometerFrame =
      requestAnimationFrame(
        animateTachometer
      );

  }


  function stopTachometer() {

    if (
      tachometerFrame !== null
    ) {

      cancelAnimationFrame(
        tachometerFrame
      );


      tachometerFrame =
        null;

    }


    tachometerStart =
      null;

  }


  buildRealTachometer();


  /* =========================================================
     LOADER
     ========================================================= */

  const messages = [
    'Pornim motorul...',
    'Pregătim fotografia pentru gravură...',
    'Așezăm mașina în design...',
    'Verificăm liniile și proporțiile...',
    'Finisăm detaliile plachetei...',
    'Preview-ul tău e aproape gata...'
  ];


  let processing =
    false;


  let activeGenerations =
    0;


  let finalImageReceived =
    false;


  let messageTimer =
    null;


  let safetyTimer =
    null;


  let finishFallbackTimer =
    null;


  let uploadFallbackTimer =
    null;


  function setMessage(
    text
  ) {

    if (
      messageNode
    ) {

      messageNode.textContent =
        text;

    }

  }


  function startMessages() {

    let index =
      0;


    setMessage(
      messages[0]
    );


    clearInterval(
      messageTimer
    );


    messageTimer =
      setInterval(
        function () {

          index =
            (
              index + 1
            ) %
            messages.length;


          setMessage(
            messages[index]
          );

        },
        3000
      );

  }


  function stopMessages() {

    clearInterval(
      messageTimer
    );


    messageTimer =
      null;

  }


  function showLoader(
    message
  ) {

    if (
      !loader
    ) {

      return;

    }


    enforceSquarePreview();


    body.classList.add(
      'lc-live-loader-active'
    );


    loader.setAttribute(
      'aria-hidden',
      'false'
    );


    setMessage(
      message ||
      'Încărcăm și pregătim fotografia...'
    );


    startTachometer();

  }


  function hideLoader() {

    processing =
      false;


    activeGenerations =
      0;


    clearTimeout(
      safetyTimer
    );


    clearTimeout(
      finishFallbackTimer
    );


    clearTimeout(
      uploadFallbackTimer
    );


    stopMessages();


    stopTachometer();


    body.classList.remove(
      'lc-live-loader-active'
    );


    if (
      loader
    ) {

      loader.setAttribute(
        'aria-hidden',
        'true'
      );

    }


    /*
      Reconfirmam patratul DUPA redraw-ul Customily.
    */

    enforceSquarePreview();

  }


  function uploadChosen() {

    finalImageReceived =
      false;


    /*
      1. Facem zona patrata.
      2. Ducem omul SUS.
      3. Ii aratam loaderul acolo.
    */

    enforceSquarePreview();


    bringPreviewIntoView();


    showLoader(
      'Încărcăm și pregătim fotografia...'
    );


    clearTimeout(
      uploadFallbackTimer
    );


    uploadFallbackTimer =
      setTimeout(
        function () {

          if (
            !processing
          ) {

            hideLoader();

          }

        },
        30000
      );

  }


  function generationStarted() {

    clearTimeout(
      uploadFallbackTimer
    );


    clearTimeout(
      finishFallbackTimer
    );


    processing =
      true;


    finalImageReceived =
      false;


    activeGenerations +=
      1;


    enforceSquarePreview();


    bringPreviewIntoView();


    showLoader(
      messages[0]
    );


    startMessages();


    clearTimeout(
      safetyTimer
    );


    safetyTimer =
      setTimeout(
        hideLoader,
        75000
      );

  }


  function generationFinished() {

    activeGenerations =
      Math.max(
        0,
        activeGenerations - 1
      );


    if (
      activeGenerations > 0
    ) {

      return;

    }


    clearTimeout(
      finishFallbackTimer
    );


    finishFallbackTimer =
      setTimeout(
        function () {

          if (
            !finalImageReceived
          ) {

            hideLoader();

          }

        },
        4500
      );

  }


  function finalImageReady() {

    if (
      !processing &&
      !body.classList.contains(
        'lc-live-loader-active'
      )
    ) {

      return;

    }


    if (
      finalImageReceived
    ) {

      return;

    }


    finalImageReceived =
      true;


    clearTimeout(
      finishFallbackTimer
    );


    setTimeout(
      function () {

        hideLoader();


        enforceSquarePreview();

      },
      900
    );

  }


  /* =========================================================
     UPLOAD CUSTOMILY
     ========================================================= */

  document.addEventListener(
    'change',
    function (event) {

      const target =
        event.target;


      if (
        !(target instanceof HTMLInputElement)
      ) {

        return;

      }


      if (
        target.type !== 'file'
      ) {

        return;

      }


      if (
        !target.files ||
        target.files.length === 0
      ) {

        return;

      }


      const section =
        target.closest(
          '.customily_section'
        );


      if (
        !section
      ) {

        return;

      }


      uploadChosen();

    },
    true
  );


  /* =========================================================
     DETECTAM IMAGINEA FINALA
     ========================================================= */

  try {

    const resourceObserver =
      new PerformanceObserver(
        function (list) {

          for (
            const entry
            of list.getEntries()
          ) {

            const url =
              entry.name || '';


            const isFinalImage =

              url.includes(
                FINAL_IMAGE_PATH
              ) &&

              /\.webp(?:\?|$)/i.test(
                url
              );


            if (
              !isFinalImage
            ) {

              continue;

            }


            finalImageReady();


            return;

          }

        }
      );


    resourceObserver.observe({
      type:
        'resource',

      buffered:
        false
    });


  } catch (error) {

    console.warn(
      '[LC LIVE] PerformanceObserver indisponibil'
    );

  }


  /* =========================================================
     XHR PASIV
     ========================================================= */

  const nativeOpen =
    XMLHttpRequest.prototype.open;


  const nativeSend =
    XMLHttpRequest.prototype.send;


  XMLHttpRequest.prototype.open =
    function (
      method,
      url,
      ...rest
    ) {

      this.__lcLiveGenerate =

        typeof url === 'string' &&

        url.includes(
          GENERATE_ENDPOINT
        );


      return nativeOpen.call(
        this,
        method,
        url,
        ...rest
      );

    };


  XMLHttpRequest.prototype.send =
    function (
      ...args
    ) {

      if (
        this.__lcLiveGenerate
      ) {

        generationStarted();


        this.addEventListener(
          'loadend',
          generationFinished,
          {
            once: true
          }
        );

      }


      return nativeSend.apply(
        this,
        args
      );

    };


  /* =========================================================
     FETCH PASIV
     ========================================================= */

  if (
    typeof window.fetch === 'function'
  ) {

    const nativeFetch =
      window.fetch;


    window.fetch =
      function (
        input,
        init
      ) {

        let url =
          '';


        if (
          typeof input === 'string'
        ) {

          url =
            input;

        } else if (
          input &&
          typeof input.url === 'string'
        ) {

          url =
            input.url;

        }


        if (
          !url.includes(
            GENERATE_ENDPOINT
          )
        ) {

          return nativeFetch.call(
            this,
            input,
            init
          );

        }


        generationStarted();


        return nativeFetch
          .call(
            this,
            input,
            init
          )
          .then(
            function (response) {

              generationFinished();


              return response;

            }
          )
          .catch(
            function (error) {

              generationFinished();


              throw error;

            }
          );

      };

  }


  console.log(
    '[LC LIVE] Light V3 activ'
  );

})();